module.exports = __webpack_public_path__ + "img/business-and-finance.84c20e62.svg";